(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/game-promotion-draw/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/game-promotion-draw/assets/javascripts/render-component.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isServer = typeof exports === 'object';
const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const {
  resolveProductId
} = isServer ? trinidad.components.require('lb-utils', 'sport-products').api : svs.components.lbUtils.sportProducts;
const {
  getProductBrandByDraw
} = isServer ? trinidad.components.require('lb-utils', 'brand-mapping').api : svs.components.lbUtils.brandMapping.fn;
const fetchDrawsByProductId = isServer ? require('./fetch-draws.es6').fetchDrawsByProductId : svs.banner_layouts.game_promotion_draw.fetchDrawsByProductId;
const fetchDrawsBySportId = isServer ? require('./fetch-draws.es6').fetchDrawsBySportId : svs.banner_layouts.game_promotion_draw.fetchDrawsBySportId;
const fetchDrawByDrawNumber = isServer ? require('./fetch-draws.es6').fetchDrawByDrawNumber : svs.banner_layouts.game_promotion_draw.fetchDrawByDrawNumber;
const fetchDrawBySportId = isServer ? require('./fetch-draws.es6').fetchDrawBySportId : svs.banner_layouts.game_promotion_draw.fetchDrawBySportId;
const {
  getJackpots
} = isServer ? trinidad.components.require('content', 'shared').jackpots : svs.content.shared;
const {
  getFunds
} = isServer ? trinidad.components.require('lb-utils', 'funds').api : svs.components.lbUtils.funds;
const {
  Currency: formatCurrency
} = isServer ? trinidad.components.require('utils', 'format').api : svs.utils.format;
const {
  getFormattedDate
} = isServer ? trinidad.components.require('lb-utils', 'helper-formatdate').api : svs.components.lbUtils.helpers.formatDate;
const getDisplayName = isServer ? trinidad.components.require('utils', 'products').getDisplayName : svs.utils.products.getDisplayName;
const {
  DrawState
} = isServer ? require('../../../../sport/tipsen-shared/assets/javascripts/tipsen-shared.es6') : svs.components.sport.tipsenShared;
const fundsConstants = {
  FUND_TYPE_ROLLOVER: 'Rollover',
  FUND_TYPE_ADJUST: 'Adjust' 
};

async function renderComponent(bannerItem, widgetInfo, position, req, res) {
  var _svs;
  const {
    branding,
    sportTypeId,
    drawNumber,
    fundSubText
  } = bannerItem.layoutConfig;
  const productId = resolveProductId(branding.split('-secondary')[0]);
  let draws = [];
  if (drawNumber) {
    draws = sportTypeId !== 'none' && sportTypeId ? await fetchDrawBySportId(productId, drawNumber, Number(sportTypeId), req) : await fetchDrawByDrawNumber(productId, drawNumber, req);
  } else {
    draws = sportTypeId !== 'none' && sportTypeId ? await fetchDrawsBySportId(productId, Number(sportTypeId), req) : await fetchDrawsByProductId(productId, req);
  }
  const draw = draws[0]; 

  if (!draw || draw.drawStateId !== DrawState.Opened) {
    return ''; 
  }
  let productBranding = getProductBrandByDraw(draw, productId);
  if (branding.includes('-secondary')) {
    productBranding += '-secondary';
  }
  const hbsCompiled = isServer ? global.internalInstances.get('hbs').cache['components-banner_layouts-game_promotion_draw-item'] :
  svs.banner_layouts.game_promotion_draw.templates.item;
  const isAdmin = isServer ?
  req.userSession.hasRole(req.userSession.roles.INTERNAL) :
  svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
  const isDesktop = isServer ? req.capabilities.formFactor === 'desktop' : svs.core.detect.formfactor.desktop();
  const trackingStringWithFixedStructure = [widgetInfo.widgetType, widgetInfo.trackingId || widgetInfo.widgetName, position, bannerItem.layoutType, bannerItem.title].join('/');
  bannerItem.images = bannerItem.images || [];

  const jackpots = isServer ? await getJackpots({
    req,
    product: productId
  }) : await getJackpots([productId]);
  const jackpot = jackpots.find(jackpot => jackpot.productId === productId && jackpot.drawNumber === draw.drawNumber);
  let funds = [];
  if (!jackpot) {
    funds = isServer ? await getFunds({
      product: productId,
      req
    }) : await getFunds({
      product: productId
    });
  }
  const fund = funds.find(f => f.drawNumber === draw.drawNumber);
  let fundTitle = '';
  let fundDate;
  if (fund && fund.type === fundsConstants.FUND_TYPE_ROLLOVER) {
    fundTitle = 'Rullpott';
    fundDate = getFormattedDate(draw.regCloseTime, true, false, true).toLowerCase();
  } else {
    fundDate = getFormattedDate(draw.regCloseTime, true, false, true).toLowerCase();
    fundTitle = 'Extrapengar';
  }
  return hbsCompiled(_objectSpread(_objectSpread({}, bannerItem.layoutConfig), {}, {
    isAdmin,
    bannerId: bannerItem.id,
    linkActionConfig: bannerItem.callToActions[0].actionConfig,
    branding: branding === '-' ? null : productBranding,
    image: bannerItem.images.find(image => image.typeName === 'productImage'),
    trackingString: trackingStringWithFixedStructure,
    crm: bannerItem.targetOffer,
    features: isServer ? res.locals.features : (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.features,
    isDesktop,
    jackpot,
    whatTypeOfTextToShow: jackpot && !jackpot.defaultJackpot ? 'jackpot' : fund ? 'fund' : 'matchdata',
    jackpotText: jackpot !== null && jackpot !== void 0 && jackpot.defaultJackpot ? undefined : jackpot ? jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmountString : undefined,
    fundText: fund ? "".concat(formatCurrency(fund.fundsAmount), " kr extra ").concat(fundDate ? " ".concat(fundDate) : '', "  ").concat(fundSubText ? "".concat(fundSubText) : '') : undefined,
    draw,
    title: draw.drawCloseTimeFormatted,
    ribbontext: jackpot && !jackpot.defaultJackpot ? 'Jackpot!' : fund ? "".concat(fundTitle, "!") : undefined,
    productName: getDisplayName(productId)
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  setGlobal('svs.banner_layouts.game_promotion_draw', {
    renderComponent
  });
}

 })(window);